
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FabComponent extends Vue {
  fab = false;
}
